import { Component } from '@angular/core'
import { AuthService, CmsProductCarouselComponent as model, ProductService } from '@spartacus/core'
import { CmsComponentData, ProductCarouselComponent } from '@spartacus/storefront'
import { Observable, of } from 'rxjs'
import { UserPermissionService } from '../../../../services/user-permission/user-permission.service'
import { map, switchMap } from 'rxjs/operators'
import { ProductDetailsService } from '../../../../services/product.service'

@Component({
    selector: 'app-custom-product-carousel',
    templateUrl: './custom-product-carousel.component.html',
    styleUrls: ['./custom-product-carousel.component.scss'],
    standalone: false
})
export class CustomProductCarouselComponent extends ProductCarouselComponent {
  isLoggedIn$: Observable<boolean>

  constructor(
    protected componentData: CmsComponentData<model>,
    protected productService: ProductService,
    private authService: AuthService,
    public userPermissionService: UserPermissionService,
    public productDetailsService: ProductDetailsService
  ) {
    super(componentData, productService)
    this.isLoggedIn$ = this.authService.isUserLoggedIn()

    // TODO:Spartacus - The type of property 'items$: Observable<Observable<Product>[]>' changed to: 'items$: Observable<Observable<Product | undefined>[]>'
    this.items$ = null
    // TODO:Spartacus - The type of property 'items$: Observable<Observable<Product>[]>' changed to: 'items$: Observable<Observable<Product | undefined>[]>'
    this.items$ = this.componentData.data$.pipe(
      map((data) => data.productCodes?.trim().split(' ') ?? []),
      map((codes) => {
        return codes.map((code) => {
          return this.productDetailsService.getProduct(code).pipe(
            switchMap((productExists) => {
              if (productExists) {
                // TODO:Spartacus - The 'get' method's signature changed to: 'get(  productCode: string,  scopes: (ProductScope | string)[] | ProductScope | string): Observable<Product | undefined>'
                // TODO:Spartacus - The type of property 'PRODUCT_SCOPE:' changed to: 'PRODUCT_SCOPE: ProductScope[]'
                return this.productService.get(code, this.PRODUCT_SCOPE)
              }
              return of(null)
            })
          )
        })
      })
    )
  }
}
